import { default as ausSuburbs } from './ausSuburbs.json';

export interface SuburbOptionType {
    suburb: string;
    postcode: string;
    state: string;
    label: string;
}

export const suburbs = ausSuburbs.map(s => ({...s, label: `${s.suburb}, ${s.state} ${s.postcode}`})) as SuburbOptionType[];
export * from './SuburbSelect';